/// <amd-module name="Dashboards/RateLimiter/DashboardRateLimitMonitorService" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IPostRequestEvent, requestListeners } from "VSS/Platform/Fetch";
import { hasHeaderThrottlingMarkings } from "./hasHeaderThrottlingMarkings";
import { HighResourceUsageInformation, IThrottleOnHighResourceUsage } from "./IThrottleHighResourceUsage";

/** No exported functions, currently. */
export interface IDashboardRateLimitMonitorService extends IVssService {
    startListening(recipient: IThrottleOnHighResourceUsage): void;
    stopListening(): void;
}

/**
 * Monitors responses passing through New Platform Fetch() API and passes Resource Utilization notifications to provided callback if thresholds are exceeded.
 */
class RateLimitMonitorService extends VssService {
    private _notifyThrottlingRecipient: ((usageInformation: HighResourceUsageInformation) => void) | null;

    public startListening(throttlingRecipient: IThrottleOnHighResourceUsage) {
        if (throttlingRecipient == null || throttlingRecipient.flagAsThrottled == null) {
            throw new Error("A Throttling recipient must be provided with an implementation for flagAsThrottled.");
        }
        this._notifyThrottlingRecipient = throttlingRecipient.flagAsThrottled;
        requestListeners.subscribe(this.handleEndRequest);
    }

    public stopListening() {
        if (this._notifyThrottlingRecipient == null) {
            throw new Error("No recipient is registered.");
        }

        this._notifyThrottlingRecipient = null;
        requestListeners.unsubscribe(this.handleEndRequest);
    }

    /** Monitors for rate limiter events of significance to dashboards. */
    private handleEndRequest = (postRequestEvent: IPostRequestEvent) => {
        if (postRequestEvent.response && postRequestEvent.response.headers) {
            if (
                hasHeaderThrottlingMarkings(postRequestEvent.response.headers.get.bind(postRequestEvent.response.headers)) &&
                this._notifyThrottlingRecipient
            ) {
                this._notifyThrottlingRecipient({
                    originatingUri: postRequestEvent.requestUrl,
                    listenerImplementationName: "RateLimitMonitorService"
                });
            }
        }
    };
}

Services.add("IDashboardRateLimitMonitorService", { serviceFactory: RateLimitMonitorService });
